export default "__VITE_ASSET__7Nwx0kyY__"